import { Injectable } from '@angular/core';
import { InputTextRenderer } from 'src/app/shared/renderers/input-text/input-text.component';
import { DuplicateButtonRenderer } from 'src/app/shared/renderers/duplicate-button/duplicate-button.component';
import { InputTextDatasetRenderer } from 'src/app/shared/renderers/input-text/input-text-dataset/input-text-dataset.component';
import { ERAPecEccAquaticLogicService } from '../../era-pec-ecc-aquatic/services/era-pec-ecc-aquatic.logic.service';
import { ERAConstants } from 'src/app/environmental-risk-assessment/environmental-risk-assessment.constants';
import { Constants } from 'src/app/shared/utils/constants';

@Injectable({
  providedIn: 'root',
})

export class ERAPecEccAquaticEuColDef {

  constructor(private readonly logicService: ERAPecEccAquaticLogicService) {}

  public getColumnsDefinition( isProjectOwnershipValid: boolean ){

    return [
      {
        headerName: 'ERA SME Selection',
        pinned: true,
        checkboxSelection: isProjectOwnershipValid,
        editable: false,
        width: 117,
        sortable: true,
        field: 'eraSmeSelection',
        hide: !isProjectOwnershipValid,
        filter: 'agSetColumnFilter',
        cellRenderer: 'checkBoxRenderer',
        cellRendererParams: {
          show: false
        }
      },
      {
        headerName: 'EEA SME Selection',
        editable: false,
        field: 'eeaSmeSelection',
        type: 'selected',
        resizable: true,
        width: 117,
        wrapText: true,
        pinned: true,
        sortable: true,
        cellRenderer: 'checkBoxRenderer',
        cellRendererParams: {
          instance: this,
          columnThatModifies: 'eeaSmeSelection',
          disabled: true
        }
      },
      {
        headerName: 'Model',
        field: 'modelName',
        width: 205,
        cellRenderer: 'dropdownlistRenderer',
        cellRendererParams: (params: any) => {
          const data = params?.data;
          return {
            options: this.logicService.modelsDropdown,
            optionValue: 'optionLabel',
            optionLabel: 'optionLabel',
            filterable: true,
            disabled: this.logicService.isDataFromRun( data, data?.runInputsPk ) || !isProjectOwnershipValid,
          }
        },
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false,
        pinned: 'left'
      },
      {
        headerName: 'Data Set',
        field: 'dataSet',
        width: 160,
        cellRenderer: InputTextDatasetRenderer,
        cellRendererParams: (params: any) => {
          const data = params?.data;
          return {
            disabled: this.logicService.isDataFromRun( data, data?.runInputsPk ) || !isProjectOwnershipValid,
          }
        },
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false,
        pinned: 'left'
      },
      {
        headerName: 'Substance',
        field: 'substance',
        width: 195,
        cellRenderer: 'dropdownlistRenderer',
        cellRendererParams: (params: any) => {
          const data = params?.data;
          return {
            options: this.logicService.substances,
            optionValue: 'optionValue',
            optionLabel: 'optionLabel',
            filterable: true,
            disabled: this.logicService.isDataFromRun( data, data?.runInputsPk ) || !isProjectOwnershipValid,
          }
        },
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false,
        pinned: 'left'
      },
      {
        headerName: 'Application Scheme',
        field: 'applicationScheme',
        width: 160,
        cellRenderer: InputTextRenderer,
        cellRendererParams: (params: any) => {
          const data = params?.data;
          return {
            disabled: this.logicService.isDataFromRun( data, data?.runInputsPk ) || !isProjectOwnershipValid,
          }
        },
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false,
        pinned: 'left'
      },
      {
        headerName: 'Scenario FOCUS',
        field: 'scenarioFocus',
        width: 120,
        cellRenderer: 'dropdownlistRenderer',
        cellRendererParams: (params: any) => {
          const data = params?.data;
          return {
            options: this.logicService.fillDropdownOptionsFromSingleList(this.logicService.getScenarioFocusListValues(data.modelName)),
            optionValue: 'optionValue',
            optionLabel: 'optionLabel',
            filterable: true,
            disabled: this.logicService.isDataFromRun( data, data?.runInputsPk ) || !isProjectOwnershipValid,
          }
        },
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'Scenarios',
        field: 'scenarios',
        width: 140,
        cellRenderer: 'dropdownlistRenderer',
        cellRendererParams: (params: any) => {
          const data = params?.data;
          return {
            options: this.logicService.fillDropdownOptionsFromSingleList(ERAConstants.SCENARIOS),
            optionValue: 'optionValue',
            optionLabel: 'optionLabel',
            filterable: true,
            disabled: this.logicService.isDataFromRun( data, data?.runInputsPk ) || !isProjectOwnershipValid || this.logicService.enableColumnForStep3And4(data.scenarioFocus),
          }
        },
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'Water Body',
        field: 'waterbody',
        width: 120,
        cellRenderer: 'dropdownlistRenderer',
        cellRendererParams: (params: any) => {
          const data = params?.data;
          return {
            options: this.logicService.waterbodiesAquatic,
            optionValue: 'optionValue',
            optionLabel: 'optionLabel',
            filterable: true,
            disabled: this.logicService.isDataFromRun( data, data?.runInputsPk ) || !isProjectOwnershipValid || this.logicService.enableColumnForStep3And4(data.scenarioFocus),
          }
        },
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'Buffer Distance (m)',
        field: 'bufferDistance',
        width: 115,
        cellRenderer: 'dropdownlistRenderer',
        cellRendererParams: (params: any) => {
          const data = params?.data;
          return {
            options: this.logicService.fillDropdownOptionsFromSingleList(ERAConstants.BUFFER),
            optionValue: 'optionValue',
            optionLabel: 'optionLabel',
            filterable: true,
            disabled: this.logicService.isDataFromRun( data, data?.runInputsPk ) || !isProjectOwnershipValid || this.logicService.enableColumnForStep4(data.scenarioFocus),
          }
        },
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'Nozzle Reduction (%)',
        field: 'nozzleDriftReduction',
        width: 110,
        cellRenderer: 'inputNumberRenderer',
        cellRendererParams:  (params: any) => {
          const data = params?.data;
            return {
            field: 'nozzleDriftReduction',
            min: 0,
            max: 100,
            maxDecimals: 0,
            disabled: this.logicService.isDataFromRun( data, data?.runInputsPk ) || !isProjectOwnershipValid || this.logicService.enableColumnForStep4(data.scenarioFocus),
          }
        },
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'Width of vegetated buffer zones(m)',
        field: 'bufferZone',
        width: 110,
        cellRenderer: 'inputNumberRenderer',
        cellRendererParams: (params: any) => {
          const data = params?.data;
          return {
            field: 'bufferZone',
            min: 0,
            max: 100,
            maxDecimals: 0,
            disabled: this.logicService.isDataFromRun( data, data?.runInputsPk ) || !isProjectOwnershipValid || this.logicService.enableColumnForStep4(data.scenarioFocus),
          }
        },
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'Region',
        field: 'region',
        width: 155,
        cellRenderer: 'dropdownlistRenderer',
        cellRendererParams: (params: any) => {
          const data = params?.data;
          return {
            options: this.logicService.fillDropdownOptionsFromSingleList(ERAConstants.REGIONS),
            optionValue: 'optionValue',
            optionLabel: 'optionLabel',
            filterable: true,
            disabled: this.logicService.isDataFromRun( data, data?.runInputsPk ) || !isProjectOwnershipValid || data?.modelName !== Constants.MODELS.STEP_1_2,
          }
        },
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'Period',
        field: 'period',
        width: 140,
        cellRenderer: 'dropdownlistRenderer',
        cellRendererParams: (params: any) => {
          const data = params?.data;
          return {
            options: this.logicService.fillDropdownOptionsFromSingleList(ERAConstants.PERIODS),
            optionValue: 'optionValue',
            optionLabel: 'optionLabel',
            filterable: true,
            disabled: this.logicService.isDataFromRun( data, data?.runInputsPk ) || !isProjectOwnershipValid || this.logicService.enableColumnForStep2(data.scenarioFocus),
          }
        },
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'Max PECsw (µg/L)',
        field: 'maxPecSw',
        width: 95,
        cellRenderer: 'inputNumberRenderer',
        cellRendererParams: (params: any) => {
          const data = params?.data;
            return {
            field: 'maxPecSw',
            maxDecimals: 4,
            disabled: this.logicService.isDataFromRun( data, data?.runInputsPk ) || !isProjectOwnershipValid,
          }
        },
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: '21 d PECsw,twa (µg/L)',
        field: 'pecSw21d',
        width: 95,
        cellRenderer: 'inputNumberRenderer',
        cellRendererParams:  (params: any) => {
          const data = params?.data;
          return {
            field: 'pecSw21d',
            maxDecimals: 4,
            disabled: this.logicService.isDataFromRun( data, data?.runInputsPk ) || !isProjectOwnershipValid,
          }
        },
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'Max PECsed (µg/kg)',
        field: 'maxPecSed',
        width: 95,
        cellRenderer: 'inputNumberRenderer',
        cellRendererParams: (params: any) => {
          const data = params?.data;
          return {
            field: 'maxPecSed',
            maxDecimals: 4,
            disabled: this.logicService.isDataFromRun( data, data?.runInputsPk ) || !isProjectOwnershipValid,
          }
        },
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'BBCH (earliest)',
        field: 'bbchEarliest',
        width: 160,
        cellRenderer: 'inputTextRender',
        cellRendererParams: (params: any) => {
          const data = params?.data;
          return {
            disabled: this.logicService.isDataFromRun( data, data?.runInputsPk ) || !isProjectOwnershipValid,
          }
        },
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false,
      },
      {
        headerName: 'Dominant Entry Route',
        field: 'dominantEnrtyRoute',
        width: 140,
        cellRenderer: 'dropdownlistRenderer',
        cellRendererParams: (params: any) => {
          const data = params?.data;
          return {
            options: this.logicService.fillDropdownOptionsFromSingleList(ERAConstants.DOMINANT_MIGRATION_GROUP),
            optionValue: 'optionValue',
            optionLabel: 'optionLabel',
            filterable: true,
            disabled: this.logicService.isDataFromRun( data, data?.runInputsPk ) || !isProjectOwnershipValid,
          }
        },
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'Global Max SW Date',
        field: 'globalMaxSwDate',
        width: 200,
        cellRenderer: 'inputTextRender',
        cellRendererParams: (params: any) => {
          const data = params?.data;
          return {
            disabled: this.logicService.isDataFromRun( data, data?.runInputsPk ) || !isProjectOwnershipValid,
          }
        },
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false,
      },
      {
        headerName: 'Application Date',
        field: 'applicationDate',
        width: 200,
        cellRenderer: 'inputTextRender',
        cellRendererParams: (params: any) => {
          const data = params?.data;
          return {
            disabled: this.logicService.isDataFromRun( data, data?.runInputsPk ) || !isProjectOwnershipValid,
          }
        },
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false,
      },
      {
        headerName: '',
        colId: 'duplicate',
        field: 'duplicateButton',
        cellRenderer: DuplicateButtonRenderer,
        type: 'rightAligned',
        width: 130,
        cellRendererParams: (params: any) =>{
          const data = params?.data;
            return {
              disabled: this.logicService.isDataFromRun( data, data?.runInputsPk ) || !isProjectOwnershipValid,
              mainTablePkName: "resultSurfaceWaterPk"
            }
        }
      },
      {
        headerName: '',
        width: 125,
        minWidth: 125,
        editable: false,
        colId: 'action',
        cellRenderer: 'deleteButtonRenderer',
        cellRendererParams: (params: any) => {
          const data = params?.data;
          return {
            disabled: this.logicService.isDataFromRun( data, data?.runInputsPk ) || !isProjectOwnershipValid,
          }
        },
        type: 'rightAligned',
      }
    ];
  }
}
